import * as React from "react";
import { StandardAutocomplete } from "@jeremyling/react-material-ui-form-builder";
import { debounce, method } from "lodash";
import { LoadingOutlined } from "@ant-design/icons";
import { CircularProgress, TextField } from "@mui/material";
import CustomAutocomplete from "./AutoComplete";
import get from "lodash/get";

const makeDefaultOption = (config) => {
    const { value, label } = config;
    return { [value]: "", [label]: "" };
};

const CustomSelect = (field, methods) => {
    const defaultOption = makeDefaultOption(field?.optionConfig);
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);

    const {
        formState: { errors },
    } = methods;

    React.useEffect(() => {
        if (field?.options?.length)
            setOptions([defaultOption, ...field.options]);
    }, [field?.options, defaultOption]);

    const fieldConfig = React.useMemo(() => {
        const config = {
            ...field,
            options,
            props: {
                ...field?.props,
                autoComplete: false,
                onOpen: () => {
                    setOpen(true);
                },
                onClose: () => {
                    setOpen(false);
                },
                renderInput: (params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        label={fieldConfig.label}
                        error={!!get(errors, fieldConfig.attribute)}
                        helperText={get(errors, fieldConfig.attribute)?.message}
                        onChange={() => {}}
                        sx={{
                            "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
                                paddingBottom: "8px",
                                paddingTop: "8px",
                            },
                            // '& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment': {
                            //     top: '2px'
                            // },
                            "& .MuiFormLabel-root-MuiInputLabel-root": {
                                top: "2px",
                            },
                            "& .base-Option-root": {
                                padding: 0,
                                backgroundColor: "red",
                            },
                        }}
                        InputProps={{
                            ...params.InputProps,
                            style: {},
                        }}
                    />
                ),
            },
        };
        return config;
    }, [options, open, errors]);

    return <CustomAutocomplete field={fieldConfig} methods={methods} />;
};

export default CustomSelect;
